import { CardHeader } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import axios from 'axios';
import numeral from 'numeral';
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import api from '../services/api';

const styles = theme => ({
  return: {
    textAlign: 'right',
    fontFamily: 'Fjalla One',
  },
  label: {
    textAlign: 'right',
  },
  flag: {
    width: "40px",
    maxHeight: "24px",
    borderRadius: "4px"
  }
});

class DetailsFundamental extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    }
  }

  toggleDescription() {
    this.setState({ descriptionOpen: !this.state.descriptionOpen })
  }

  async componentDidMount() {
    
    api.get('trading/fundamental/' + this.props.id)
      .then(response => {
        const data = response.data
        this.setState({ data });
      }).catch(error => {
        console.log(error);
      })
  }

  render() {
    const { data } = this.state;
    return (
      <Card variant="outlined">
        <CardHeader sx={{ p: '16px 16px 0 16px!important' }}
          title={<Typography variant='overline'><Trans>{"DetailsFundamentalTitle"}</Trans></Typography>}
        />
        <CardContent>
          <Box sx={{ py: 2 }}>
            <Box sx={{ display: 'flex', mb: 2 }}>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{numeral(data.cap).format('0,000.00a').toUpperCase()} <small style={{ fontSize: 12 }}>{data.curr}</small></Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Market capitalization</Typography></Box>
              </Box>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.peratio}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>PE ratio</Typography></Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', mb: 2 }}>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.earningsshare}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Earnings per share (EPS)</Typography></Box>
              </Box>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{numeral(data.ebitda).format('0,000.00a').toUpperCase()} <small style={{ fontSize: 12 }}>{data.curr}</small></Typography></Box>
                <Box><Typography variant='caption' color='secondary'>EBITDA</Typography></Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', mb: 2 }}>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.dividendyield}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Dividend yield</Typography></Box>
              </Box>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.beta}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Beta</Typography></Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', mb: 2 }}>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.quarterlyearningsgrowthyoy}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Quarterly earnings growth</Typography></Box>
              </Box>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.forwardpe}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Forward PE</Typography></Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.pricesalesttm}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Price/Sales</Typography></Box>
              </Box>
              <Box sx={{ flex: '50%', display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{data.pricebookmrq}</Typography></Box>
                <Box><Typography variant='caption' color='secondary'>Price/Book ratio</Typography></Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  }
}

export default DetailsFundamental;
